<template>
	<div class="vrp-app-container">
		<router-view></router-view>
		<VrpNotificationQueuePopup />
		<VrpNotificationQueueToast />
	</div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed, provide } from 'vue';
import { useStore } from './store';
import { useStoreData } from '@/vrp/store_data';
import { LoginScenarioState, SecretNumberState } from '@vrp/js/types';
import VrpNotificationQueuePopup from '@/vrp/components/common/VrpNotificationQueuePopup.vue';
import VrpNotificationQueueToast from '@/vrp/components/common/VrpNotificationQueueToast.vue';

const store = useStore();
const storeData = useStoreData();

// 전역으로 제공 (provide)
provide('store', store);
provide('storeData', storeData);

const handlePopState = function () {
	if (store.is_triggered_history_back_by_develover === false) {
		store.setModalState({
			login_modal_state: LoginScenarioState.None,
			// 생략된 모달 상태 설정들...
			region: {
				isShowingAreaRegCancelPopup: false,
				isShowingAreaDeletePopup: false,
				isShowingRegionAddressSearchUi: false,
				isShowingNotDriverPopup: false,
			},
			account: {
				isShowinglogoutPopup: false,
				isShowingPassword: SecretNumberState.None,
				isShowingEmail: false,
				isShowingCorpAddress: false,
				isShowingMemberWithdraw: false,
			},
			dashboard: {
				isShowingPersonalInfoPolicy: true,
			},
		});
	}
	store.is_triggered_history_back_by_develover = false;
};

function requestLocation() {
	if (navigator.permissions) {
		navigator.permissions
			.query({ name: 'geolocation' })
			.then(permissionStatus => {
				if (
					permissionStatus.state === 'granted' ||
					permissionStatus.state === 'prompt'
				) {
					getCurrentLocation();
				} else if (process.env.VUE_APP_BUILD_MODE === 'DEV') {
					console.log('사용자 위치권한 denied');
				}
			});
	} else {
		getCurrentLocation();
	}
}

const getCurrentLocation = () => {
	if (navigator.geolocation) {
		navigator.geolocation.getCurrentPosition(
			position => {
				store.setCurLocation({
					latitude: position.coords.latitude,
					longitude: position.coords.longitude,
				});
			},
			error => {
				if (process.env.VUE_APP_BUILD_MODE === 'DEV') {
					console.error('위치 정보를 가져오는 데 실패했습니다:', error);
				}
			},
		);
	} else if (process.env.VUE_APP_BUILD_MODE === 'DEV') {
		console.error('Geolocation API를 지원하지 않습니다.');
	}
};

onMounted(() => {
	requestLocation();
	window.addEventListener('popstate', handlePopState);
});

onBeforeUnmount(() => {
	window.removeEventListener('popstate', handlePopState);
});

// ////버전 체크에 따른 캐시 제거 로직 추가
// let userVersion = localStorage.getItem('userVersion') || '1.0.0';
// let latestVersion = process.env.VUE_APP_VERSION;
// // Compare user version with the latest version on mount
// onMounted(async () => {
// 	if (userVersion !== latestVersion) {
// 		console.log('버전이 달라서 업데이트');
// 		await clearCache(); // 캐시 삭제 후 새로고침
// 		refreshPage();
// 	}
// });

// const clearCache = async () => {
// 	if ('caches' in window) {
// 		try {
// 			const cacheNames = await caches.keys(); // 현재 존재하는 모든 캐시 이름 가져오기
// 			console.log('Cache Names:', cacheNames); // 캐시 이름들을 출력하여 확인

// 			if (cacheNames.length === 0) {
// 				console.log('삭제할 캐시가 없습니다.');
// 			}

// 			for (const cacheName of cacheNames) {
// 				console.log(cacheName, '캐시 삭제 시도');
// 				const success = await caches.delete(cacheName); // 캐시 삭제 시도
// 				if (success) {
// 					console.log(cacheName, '성공적으로 삭제되었습니다.');
// 				} else {
// 					console.log(cacheName, '삭제 실패했습니다.');
// 				}
// 			}
// 		} catch (error) {
// 			console.error('캐시 삭제 중 오류 발생:', error); // 에러가 발생했을 경우 출력
// 		}
// 	} else {
// 		console.warn('Cache API를 지원하지 않는 브라우저입니다.');
// 	}
// };

// const refreshPage = () => {
// 	localStorage.setItem('userVersion', latestVersion);
// 	// window.location.reload();
// };
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100..900&display=swap');
@import url('https://cdnjs.cloudflare.com/ajax/libs/meyer-reset/2.0/reset.min.css');
* {
	-webkit-font-smoothing: antialiased;
	box-sizing: border-box;
}
html,
body {
	margin: 0px;
	font-family: 'Noto Sans KR', sans-serif;
	font-optical-sizing: auto;
	font-style: normal;
}
.vrp-app-container {
	display: flex;
	flex-direction: row;
}
</style>
